import _startCase from 'lodash/startCase'
import { track, MIXPANEL_EVENT } from 'ggx-service/mixpanel/mixpanel'
import { brazeClient, BRAZE_EVENT } from 'ggx-service/braze'
import moment from 'moment-timezone'


const getDateFilter = (startDate, endDate) => {
  let date_filter;
  const start_date = moment(startDate);
  const end_date = moment(endDate);
  if (end_date.isSame(new Date(), "day")) {
    if (end_date.subtract(1, "day").isSame(start_date, "day")) {
      date_filter = "yesterday"
    } else if (end_date.subtract(7, "days").isSame(start_date, "day")) {
      date_filter = "last_week"
    }
  }
  if (!date_filter) {
    date_filter = start_date.format("YYYY-MM-DD") + " to " + end_date.format("YYYY-MM-DD");
  }
  return date_filter;
}

export default {
  trackDeliveryDownloadReport: (params, total_record_count) => {
    const properties = {
      from: params?.from,
      to: params?.to,
      order_status_filter: params?.status ?? "",
      date_filter: getDateFilter(params?.from, params?.to),
      order_search_filter: params?.q || undefined,
      total_record_count,
      file_type: params?.file_type,
    }
    track(MIXPANEL_EVENT.DELIVERY.ORDER_MANAGEMENT.DOWNLOAD_REPORT, properties)
    brazeClient.setCustomEvent(BRAZE_EVENT.DELIVERY.DOWNLOAD_REPORT, properties)
  },
  trackTransportDownloadReport: (params, total_record_count) => {
    const properties = {
      start_date: params.startDate,
      end_date: params.endDate,
      status: params.status,
      branch: params.branch,
      sort: params.sort,
      order_status_filter: params?.status ? _startCase(params.status) : '',
      date_filter: getDateFilter(params.startDate, params.endDate),
      order_search_filter: params?.q || undefined,
      total_record_count,
      file_type: params?.file_type,
    }
    track(MIXPANEL_EVENT.TRANSPORT.DOWNLOAD_REPORT, properties)
    brazeClient.setCustomEvent(BRAZE_EVENT.TRANSPORT.DOWNLOAD_REPORT, properties)
  },
  trackFinishedGeneratingReport: async (eventName, cb) => {
    const start_time = Date.now()
    let status, error_reason, processing_time_ms
    try {
      await cb()
      status = 'Success'
    } catch (error) {
      status = 'Failure'
      error_reason = error?.message || 'Unknown error'
      throw error
    }
    finally {
      processing_time_ms = Date.now() - start_time
      track(eventName, {
        status,
        error_reason,
        processing_time_ms,
      })
      brazeClient.setCustomEvent(eventName, {
        status,
        error_reason,
        processing_time_ms,
      })
    }
  }
}
